import DragItem from "../../ddTxtImg/model/DragItem"
import $ from 'jquery'
import 'jquery-ui'
import 'jquery-ui-dist/jquery-ui';
import ReactDOM from 'react-dom';



class DropItem {

    constructor() {
        this.dropItem = null
        this.dragList = []
        this.solvedDragItem = new DragItem()
    }

    initDropItem = (activity) => {
        console.log("initDropItem")
        console.log(this.solvedDragItem)
        if (this.solvedDragItem.dragIndex != -1) {
           // this.dropItem.innerHTML = this.solvedDragItem.dragTxt.replace(/<[^>]*>/g, '');
           this.dropItem.innerHTML = (activity.currentDragItem.dragViewTxt != "" ? activity.currentDragItem.dragViewTxt : activity.currentDragItem.dragTxt )

            if (this.checkDropItemSolution()) {
                this.dropItem.style.color = "green"

            }
            else {
                this.dropItem.style.color = "red"

            }
        }

        $("#" + this.dropItem.id).droppable(
            {
                drop: (e) => {
                    // console.log("this DropItem")
                    // console.log(this)
                    console.log("activity.currentDragItem")
                    console.log(activity.currentDragItem)
                    //e.target.innerHTML =  activity.currentDragItem.dragViewTxt 
                    e.target.innerHTML = (activity.currentDragItem.dragViewTxt != "" &&  activity.currentDragItem.dragViewTxt != undefined? activity.currentDragItem.dragViewTxt : activity.currentDragItem.dragTxt )
                    //e.target.innerHTML = activity.currentDragItem.dragTxt.replace(/<[^>]*>/g, '');
                    this.solvedDragItem = activity.currentDragItem
                }
            }
        )
    }

    checkDropItemSolution = () => {

        let result = false
        for (let j = 0; j < this.dragList.length; j++) {

            if (this.solvedDragItem.dragIndex == this.dragList[j].dragIndex) {
                result = true
            }

        }

        return result;
    }


    getReportAsJson = () => {


        let obj = {}
        obj.dropItemId = this.dropItem.id
        obj.dragList = []
        for(let i=0;i<this.dragList.length;i++){
            obj.dragList.push(this.dragList[i].getReportAsJson())
        }
        obj.solvedDragItem = this.solvedDragItem

        return obj
    }

    initReportFromJson = (obj) => {

        this.dropItemId = obj.dropItemId
        this.dragList = obj.dragList
        this.solvedDragItem = obj.solvedDragItem
    }
}

export default DropItem